
import React from 'react';
import { IMAGES } from '../constants';

export const Hero: React.FC = () => {
  return (
    <div className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-white">
      {/* Background Image - Elegant B&W Photography */}
      <div 
        className="absolute inset-0 z-0 scale-105 pointer-events-none"
        style={{
          backgroundImage: `url('${IMAGES.hero}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'grayscale(100%) brightness(0.9) contrast(1.1)',
        }}
      />
      
      {/* Subtle White Wash Overlay to maintain the "White background" feel */}
      <div className="absolute inset-0 z-10 bg-white/30 backdrop-blur-[2px]" />
      
      {/* Centered Content - Black Typography on Faded Photo */}
      <div className="relative z-20 text-center px-4 max-w-4xl border-x border-black/[0.05] py-24 bg-white/40 backdrop-blur-md md:bg-transparent md:backdrop-blur-none">
        <p className="text-[10px] md:text-xs tracking-[0.6em] mb-10 uppercase animate-fade-in-down text-black font-bold">
          you are invited
        </p>
        
        <h1 className="font-serif-display italic text-7xl md:text-9xl mb-12 animate-fade-in text-black tracking-tighter leading-[1.1] md:leading-none">
          Heather <span className="block md:inline md:mx-4 font-script not-italic text-5xl md:text-7xl lowercase opacity-20">&</span> Jordan
        </h1>
        
        <div className="flex items-center justify-center gap-6 mb-12 opacity-20">
          <div className="w-16 h-[0.5px] bg-black" />
          <div className="w-1.5 h-1.5 rounded-full bg-black" />
          <div className="w-16 h-[0.5px] bg-black" />
        </div>
        
        <p className="text-xl md:text-3xl font-serif-display italic animate-fade-in-up text-black font-medium">
          Saturday, June 13th 2026
        </p>
        
        <p className="mt-8 text-xs md:text-sm tracking-[0.5em] font-bold animate-fade-in-up text-black uppercase">
          Enterkine House • Ayrshire
        </p>
      </div>

      {/* Minimalist Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-20 animate-bounce">
        <div className="w-[1px] h-16 bg-gradient-to-b from-black/0 via-black/40 to-black/0" />
      </div>

      <style>{`
        @keyframes fade-in-down {
          0% { opacity: 0; transform: translateY(-30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          0% { opacity: 0; filter: blur(15px); }
          100% { opacity: 1; filter: blur(0); }
        }
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};